<template>
  <div>
    <common-table
        :table-columns="tableColumns"
        :url="url" :operate="operate"
        :form-fields="formFields"
        :permission="permission"
        :searchs="searchs"
        :buttons="buttons"
        ref="table"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
export default {
  name: "WalletAgent",
  components: {CommonTable},
  data() {
    return {
      searchs:[{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectValue:[],
        selectUrl: '/agent/getAll',
      }, {
        name: 'startTime',
        placeholder: '开始时间',
        type: 'dateTime'
      }, {
        name: 'endTime',
        placeholder: '结束时间',
        type: 'dateTime'
      }, {
        name: 'type',
        placeholder: '类型',
        type: 'select',
        selectValue:[{
          key: 1,
          value: '出款'
        },{
          key: 2,
          value: '收款'
        }, {
          key: 3,
          value: 'U钱包'
        }]
      },],
      permission:{
        // add: 'walletAgent:add',
        update: 'walletAgent:update',
        delete: 'walletAgent:delete',
        deleteBatch: 'walletAgent:deleteBatch'
      },
      url: {
        get: '/walletAgent/listByCondition',
        add: '/walletAgent/add',
        update: '/walletAgent/update',
        delete: '/walletAgent/delete/',
        delete_batch: '/walletAgent/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }/*, {
                    field: 'privateKey',
                    label: '私钥',
                    show: true,
                    width: '',
                }*/, {
        field: 'address',
        label: '钱包地址',
        show: true,
        width: '',
      }, {
        field: 'minAmount',
        label: '最小金额',
        show: true,
        width: '',
      }, {
        field: 'balance',
        label: 'USDT余额',
        show: true,
        width: '',
      }, {
        field: 'trxBalance',
        label: '余额',
        show: true,
        width: '',
      }, {
        field: 'maxAmount',
        label: '最大金额',
        show: true,
        width: '',
      }, {
        field: 'type',
        label: '类型',
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '出款',
            type: 'primary'
          },{
            key: 2,
            value: '收款',
            type: 'warning'
          }, {
            key: 3,
            value: 'U钱包'
          }]
        },
        width: '100'
      }, {
        field: 'currency',
        label: '网络',
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: 'TRC20',
            type: 'primary'
          },{
            key: 2,
            value: 'ERC20',
            type: 'warning'
          }]
        },
        width: '100'
      }, {
        field: 'autoReview',
        label: '审核类型',
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '自动审核',
            type: 'primary'
          },{
            key: 0,
            value: '手动审核',
            type: 'warning'
          }]
        }
      }, {
        field: 'collectType',
        label: '能量方式',
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '购买方式',
            type: 'primary'
          },{
            key: 2,
            value: '转出方式',
            type: 'warning'
          }]
        },
        width: '100'
      },{
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [{
        icon: 'el-icon-search',
        type: 'text',
        text: '查询余额(USDT)',
        handle: (row) => {
          this.$axios.post({
            url: '/walletAgent/balance/search/1/' + row.id,
            success: (res) => {
              if (res.code === 0) {
                this.$set(row, 'balance', res.data);
              }
            }
          })
        }
      },{
        icon: 'el-icon-search',
        type: 'text',
        text: '查询余额(TRX)',
        handle: (row) => {
          this.$axios.post({
            url: '/walletAgent/balance/search/2/' + row.id,
            success: (res) => {
              if (res.code === 0) {
                this.$set(row, 'trxBalance', res.data);
              }
            }
          })
        }
      }],
      formFields: {
        addTitle: '添加收款钱包',
        updateTitle: '修改收款钱包',
        labelWidth: '80px',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'address',
          label: '钱包地址',
          type: 'input',
          placeholder: '钱包地址',
          rules:[{message: '请输入钱包地址', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'privateKey',
          label: '私钥',
          type: 'input',
          placeholder: '私钥',
          rules:[],
          add: false,
          update: false,
        }, {
          field: 'minAmount',
          label: '最小金额',
          type: 'input',
          placeholder: '最小金额(USDT)',
          rules:[{
            message: '请输入最小金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'maxAmount',
          label: '最大金额',
          type: 'input',
          placeholder: '最大金额(USDT)',
          rules:[{
            message: '请输入最大金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'type',
          label: '类型',
          type: 'select',
          selectData: [{
            id: 1,
            name: '出款'
          }, {
            id: 2,
            name: '收款'
          }, {
            key: 3,
            value: 'U钱包'
          }],
          placeholder: '类型',
          rules:[],
          add: false,
          update: {
            disabled: true
          },
        },{
          field: 'currency',
          label: '网络',
          type: 'select',
          selectData: [{
            id: 1,
            name: 'TRC20'
          }, {
            id: 2,
            name: 'ERC20'
          }],
          placeholder: '网络',
          rules:[{
            message: '请选择网络', trigger: 'blur', required: true
          }],
          add: true,
          update: {
            disabled: true
          },
        },{
          field: 'autoReview',
          label: '审核类型',
          type: 'select',
          selectData: [{
            id: 1,
            name: '自动审核'
          }, {
            id: 0,
            name: '手动审核'
          }],
          placeholder: '类型',
          rules:[{
            message: '请选择审核类型', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },{
          field: 'collectType',
          label: '能量方式',
          type: 'select',
          selectData: [{
            id: 1,
            name: '购买'
          }, {
            id: 2,
            name: '转出'
          }],
          placeholder: '类型',
          rules:[{
            message: '请选择能量方式', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }/*, {
          field: 'code',
          label: '验证码',
          type: 'input',
          placeholder: '谷歌验证码',
          rules:[{
            message: '请输入谷歌验证码', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'tgCode',
          label: '纸飞机验证码',
          type: 'code',
          placeholder: '纸飞机验证码',
          rules:[{
            message: '请输入纸飞机验证码', trigger: 'blur', required: true
          }],
          add: {
            url: '/system/getTgCode/addWalletAgent',
            second: 60
          },
          update: {
            url: '/system/getTgCode/updateWalletAgent',
            second: 60
          },
        }*/],
        editFunc: (row) => {
          if (row.type === 1) {
            this.formFields.updateTitle = '修改出款钱包';
            this.formFields.model.forEach(item => {
              if (item.field === 'address') {
                item.update = false;
              }
              if (item.field === 'autoReview') {
                item.update = true;
              }
              if (item.field === 'privateKey') {
                item.update = false;
              }
            })
          } else if (row.type === 2) {
            this.formFields.updateTitle = '修改收款钱包';
            this.formFields.model.forEach(item => {
              if (item.field === 'address') {
                item.update = true;
              }
              if (item.field === 'autoReview') {
                item.update = false;
              }
              if (item.field === 'privateKey') {
                item.update = false;
              }
            })
          }else if (row.type === 3) {
            this.formFields.updateTitle = '修改U钱包';
            this.formFields.model.forEach(item => {
              if (item.field === 'address') {
                item.update = false;
              }
              if (item.field === 'autoReview') {
                item.update = false;
              }
              if (item.field === 'privateKey') {
                item.update = false;
              }
            })
          }
        }
      },
      buttons: [{
        icon: 'el-icon-circle-plus',
        type: 'primary',
        text: '添加收款钱包',
        permission: 'walletAgent:add',
        click: () => {
          this.formFields.addTitle = "添加收款钱包";
          this.formFields.model.forEach(item => {
            if (item.field === 'address') {
              item.add = true;
            }
            if (item.field === 'autoReview') {
              item.add = false;
            }
            if (item.field === 'privateKey') {
              item.add = false;
            }
          })
          this.$refs.table.addForm.type = 2;
          this.$refs.table.open_add_dv();
        }
      }, {
        icon: 'el-icon-circle-plus',
        type: 'primary',
        text: '添加出款钱包',
        permission: 'walletAgent:add',
        click: () => {
          this.formFields.addTitle = "添加出款钱包";
          this.formFields.model.forEach(item => {
            if (item.field === 'address') {
              item.add = false;
            }
            if (item.field === 'autoReview') {
              item.add = true;
            }
            if (item.field === 'privateKey') {
              item.add = false;
            }
          })
          this.$refs.table.addForm.type = 1;
          this.$refs.table.open_add_dv();
        }
      }, {
        icon: 'el-icon-circle-plus',
        type: 'primary',
        text: '添加U钱包',
        permission: 'walletAgent:add',
        click: () => {
          this.formFields.addTitle = "添加U钱包";
          this.formFields.model.forEach(item => {
            if (item.field === 'address') {
              item.add = false;
            }
            if (item.field === 'autoReview') {
              item.add = false;
            }
            if (item.field === 'privateKey') {
              item.add = false;
            }
          })
          this.$refs.table.addForm.type = 3;
          this.$refs.table.open_add_dv();
        }
      }]
    }
  }

}
</script>

<style scoped>

</style>
